import { render, staticRenderFns } from "./ReadOnly_chat.vue?vue&type=template&id=69ca5b83&"
import script from "./ReadOnly_chat.vue?vue&type=script&lang=js&"
export * from "./ReadOnly_chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports